export const adjustTemplateById = data => {
  const { vehicleId: vehicle } = data;
  return {
    ...data,
    id: data && data.offerTemplateId,
    name: data && data.offerTemplateName,
    vehicle: vehicle
      ? `${
          vehicle.vehicleModelId && vehicle.vehicleModelId.vehicleBrandId
            ? vehicle.vehicleModelId.vehicleBrandId.brandName
            : ''
        } ${
          vehicle && vehicle.vehicleModelId && vehicle.vehicleModelId.modelName
            ? vehicle.vehicleModelId.modelName
            : ''
        }, ${vehicle && vehicle.registerSign ? vehicle.registerSign : ''} ${
          vehicle && vehicle.registerRegion ? vehicle.registerRegion : ''
        }`
      : '',
    vehicleId: vehicle && vehicle.vehicleId,
  };
};

export const adjustTemplateSend = (profileId, data) => {
  // console.log('template', data);
  let newData = {
    profile_id: profileId,
    t2: data.t2 ? data.t2 : '',
    t4: data.t4 ? data.t4 : '',
    t6: data.t6 ? data.t6 : '',
    t7: data.t7 ? data.t7 : '',
    t8: data.t8 ? data.t8 : '',
    t9: data.t9 ? data.t9 : '',
    sh1: data.sh1 ? data.sh1 : '',
    sh2: data.sh2 ? data.sh2 : '',
    sh3: data.sh3 ? data.sh3 : '',
    kp1t: data.kp1t ? data.kp1t : '',
    kp2t: data.kp2t ? data.kp2t : '',
    kp3t: data.kp3t ? data.kp3t : '',
    kp4t: data.kp4t ? data.kp4t : '',
    kp1p: data.kp1p ? data.kp1p : '',
    kp2p: data.kp2p ? data.kp2p : '',
    kp3p: data.kp3p ? data.kp3p : '',
    kp4p: data.kp4p ? data.kp4p : '',
    kz1t: data.kz1t ? data.kz1t : '',
    kz2t: data.kz2t ? data.kz2t : '',
    kz3t: data.kz3t ? data.kz3t : '',
    kz4t: data.kz4t ? data.kz4t : '',
    kz1p: data.kz1p ? data.kz1p : '',
    kz2p: data.kz2p ? data.kz2p : '',
    kz3p: data.kz3p ? data.kz3p : '',
    kz4p: data.kz4p ? data.kz4p : '',
    s1: data.s1 ? data.s1 : '',
  };

  if (data.templateId) newData.offer_template_id = data.templateId;
  if (data.vehicleId) newData.vehicle_id = data.vehicleId;
  if (data.type === 'order' || data.type === 'offer') {
    if (data.templateName) newData.offer_template_name = data.templateName;
  } else {
    newData.offer_template_name = data.name ? data.name : '';
  }
  return newData;
};
